import React, { JSX } from "react";
import { Navigate } from "react-router-dom";

interface AuthGuardProps {
  component: JSX.Element;
  requiresAuth: boolean;
}

const AuthGuard: React.FC<AuthGuardProps> = ({ component, requiresAuth }) => {
  const isAuthenticated = !!localStorage.getItem("sessionToken");
  const isAuthenticatedDev = !!localStorage.getItem("sessionTokenDev");

  if (!requiresAuth || isAuthenticatedDev) {
    return component;
  }

  return isAuthenticated ? component : <Navigate to="/" replace />;
};

export default AuthGuard;
